import React, {FC, useCallback, useEffect, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {useLoadedData} from '../../../../hooks/useGetLoadedData'
import {PaginateParams} from '../../../../../services/cellcast.v2.types'
import {useLazyAdminGetAffiliateQuery} from '../../../../../services/cellcast.v2'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import moment from 'moment-timezone'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../../Components/NodataYet'
import { useLocation } from 'react-router-dom'

type ReferralAffiliateListProps = {}
export const ReferralAffiliateList: FC<ReferralAffiliateListProps> = (req, res) => {
  const {calculate, loadedData, setLoadedData} = useLoadedData()

  const location = useLocation()
  const {userProp} = location.state || ({} as any)
  
  const userDataState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user || {})
  const userData = userProp?.user ? userProp.user : userDataState

  const [params, setParams] = useState<PaginateParams>({
    page: 1,
    limit: 10,
  })

  const [triggerFetch, setTriggerFetch] = useState(false)

  const [fetch, {isLoading, data, isFetching}] = useLazyAdminGetAffiliateQuery()

  useEffect(() => {
    if (userData._id) {
      fetch({...params, userId: userData._id})
    }
  }, [userData])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch({...params, userId: userData._id})
    }
    setTriggerFetch(false)
  }, [triggerFetch])

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  return (
    <div className='mt-8'>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Affiliate Users</span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'>{/* space for filter component */}</div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='max-w-100px'>Code</th>
                        <th className='min-w-150px'>Name</th>
                        <th className='min-w-140px'>Company</th>
                        <th className='min-w-140px'>Email</th>
                        <th className='min-w-100px'>JOINED-DATE</th>
                        <th className='min-w-100px text-center'>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={5} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((item, i: number) => (
                            <React.Fragment key={i}>
                              {' '}
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  <div
                                    className='text-mute text-center fs-8'
                                    style={{
                                      backgroundColor: 'rgb(245, 248, 250)',
                                      padding: '5px 10px',
                                      borderRadius: 5,
                                    }}
                                  >
                                    {item.referralCode}
                                  </div>
                                </td>
                                <td className='top-align'>{item.name || '--'}</td>
                                <td className='top-align'>{item.companyName || '--'}</td>
                                <td className='top-align'>{item.email || '--'}</td>
                                <td className='top-align'>
                                  <span className='text-dark-400  p-0'>
                                    {moment(item.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                                  </span>
                                </td>
                                <td className='text-center'>--</td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                      setTriggerFetch(true)
                    }}
                    value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } Messages`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                      setTriggerFetch(true)
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No affiliate user (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default ReferralAffiliateList
